import React from 'react';
import styles from '../../styles/components/tab/Tab.module.css';
import TabLabel, { TabLabelProps } from './TabLabel';
import _ from 'lodash';

export interface TabProps {
  name: string;
  label: string | TabLabelProps;
  content?: React.ReactNode;
  isCompleted?: string;
  onPreventClick?: () => void; // TODO: remove it
}

export interface TabHeaderProps extends TabProps {
  active?: boolean;
  onClick?: (name: string) => void;
}

export interface TabContentProps extends TabProps {
  active?: boolean;
}

export const TabHeader: React.FC<TabHeaderProps> = ({
  name,
  label,
  active,
  isCompleted,
  onPreventClick,
  onClick,
}) => {
  const handleClick = (event: React.MouseEvent) => {
    if (onPreventClick) {
      event.preventDefault();
      onPreventClick();
    } else {
      onClick && onClick(name);
    }
  };
  return (
    <li
      key={name + '-header'}
      className={[styles.header, active ? styles.active : ''].join(' ')}
      onClick={handleClick}
    >
      <TabLabel
        {...(_.isString(label) ? { title: label } : label)}
        active={active}
        isCompeleted={isCompleted}
      />
    </li>
  );
};

export const TabContent: React.FC<TabContentProps> = ({
  name,
  active,
  content,
}) => {
  return (
    <div key={name + '-content'} className={styles.content}>
      {active && content}
    </div>
  );
};
